import React from "react"

const Footer = () => {
  return (
    <footer className="my-12">

    </footer>
  )
}

export default Footer
